import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  HostBinding,
  inject,
  OnInit
} from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { VexConfigService } from '@vex/config/vex-config.service';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { NavigationService } from '../../../core/navigation/navigation.service';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { MegaMenuComponent } from './mega-menu/mega-menu.component';
import { Observable, of } from 'rxjs';
import { NavigationComponent } from '../navigation/navigation.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { NavigationItemComponent } from '../navigation/navigation-item/navigation-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NavigationItem } from '../../../core/navigation/navigation-item.interface';
import { checkRouterChildsData } from '@vex/utils/check-router-childs-data';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { AdminService } from 'src/app/services/admin.service';
import { jwtDecode } from 'jwt-decode';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MailComponent } from 'src/app/pages/mail/containers/mail.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AutoPageSearchComponent } from "src/app/shared/auto-page-search/auto-page-search.component";
import { MailService } from 'src/app/pages/mail/services/mail.service';
import { MailAccountMissingDialogComponent } from 'src/app/shared/dialog/mail-account-missing-dialog.component';
import { NavigationLoaderService } from 'src/app/core/navigation/navigation-loader.service';
import { MenuAccessService } from 'src/app/core/navigation/menu-access.service';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    NgIf,
    RouterLink,
    MatMenuModule,
    NgClass,
    NgFor,
    NavigationItemComponent,
    ToolbarNotificationsComponent,
    ToolbarUserComponent,
    NavigationComponent,
    AsyncPipe, ReactiveFormsModule, MatFormFieldModule, MatSelectModule,
    AutoPageSearchComponent
  ]
})
export class ToolbarComponent implements OnInit, AfterViewInit {
  @HostBinding('class.shadow-b')
  showShadow: boolean = false;

  navigationItems$: Observable<NavigationItem[]> =
    this.navigationService.items$;

  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.layout === 'horizontal')
  );
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.layout === 'vertical')
  );

  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.navbar.position === 'in-toolbar')
  );
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.navbar.position === 'below-toolbar')
  );
  userVisible$: Observable<boolean> = this.configService.config$.pipe(
    map((config) =>
      config.toolbar.user.visible &&
      config.navbar.position === 'in-toolbar' &&
      config.sidenav.user.visible === false
    )
  );
  title$: Observable<string> = this.configService.select(
    (config) => config.sidenav.title
  );

  isDesktop$: Observable<boolean> = this.layoutService.isDesktop$;
  megaMenuOpen$: Observable<boolean> = of(false);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly hostElement = inject<ElementRef<HTMLElement>>(ElementRef);
  private resizeObserver?: ResizeObserver;
  companylist: any;
  financelist: any;
  branchlist: any;
  tk = JSON.parse(localStorage.getItem('tokenaccess')!);
  companyid1 = new FormControl('');
  branchid1 = new FormControl<number | null>(null);
  fyid1 = new FormControl('');
  decode = jwtDecode(localStorage.getItem('token')!) as any;
  token: any;
  userid: any;
  mailEnabled = false;
  constructor(
    private readonly layoutService: VexLayoutService,
    private readonly configService: VexConfigService,
    private readonly navigationService: NavigationService,
    private readonly popoverService: VexPopoverService,
    public dialog: MatDialog,
    private readonly router: Router, private service: AdminService,
    private mailService: MailService,
    private readonly navigationLoader: NavigationLoaderService,
    private readonly menuAccess: MenuAccessService
  ) {

    this.service.getcompanylist().subscribe((res: any) => {
      this.companylist = res
    })

    this.service.getfinancelist(localStorage.getItem('token')).subscribe((res: any) => this.financelist = res)
    if (this.tk.companyId > 0) {
      this.service.getbranchlistmappingbyuseridandcompanyidforlogin(this.decode.unique_name, this.tk.companyId, localStorage.getItem('token')).subscribe((res: any) => { this.branchlist = res })
    }

    this.menuAccess.ensureMenuSnapshot().then(() => {
      this.navigationLoader.triggerNavigationReload();
    });

  }

  ngOnInit() {

    this.service.branchId$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(branchId => {
        if (!branchId) return;

        // wait until branchlist present
        if (this.branchlist?.length) {
          this.branchid1.setValue((branchId));
        }
      });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.showShadow = checkRouterChildsData(
          this.router.routerState.root.snapshot,
          (data) => data.toolbarShadowEnabled ?? false
        );
      });

    this.tk = JSON.parse((sessionStorage.getItem('tokenaccess') || localStorage.getItem('tokenaccess'))!);
    if (!sessionStorage.getItem('tokenaccess')) {
      sessionStorage.setItem('tokenaccess', localStorage.getItem('tokenaccess')!);
    }

    this.token = localStorage.getItem('token');
    const decode = jwtDecode(this.token) as any;
    this.userid = decode.unique_name;
    this.companyid1.setValue(this.tk.companyId);
    this.branchid1.setValue(this.tk.branchId);
    this.fyid1.setValue(this.tk.financeId);
    this.refreshMailAccess();
  }

  ngAfterViewInit() {
    this.syncToolbarHeight();

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.syncToolbarHeight());
      this.resizeObserver.observe(this.hostElement.nativeElement);
      this.destroyRef.onDestroy(() => this.resizeObserver?.disconnect());
    }
  }

  openQuickpanel(): void {
    this.layoutService.openQuickpanel();
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement): void {
    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: MegaMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }

  openSearch(): void {
    this.layoutService.openSearch();
  }

  companyChange(companyId: any) {
    const tokenAccessStr = localStorage.getItem('tokenaccess');

    this.service.updateCompanyInfo(
      (this.companylist.find((o: any) => o.id == companyId.value)).logobase64,
      (this.companylist.find((o: any) => o.id == companyId.value)).shortname,
      (this.companylist.find((o: any) => o.id == companyId.value)).defaultdashboardpath
    );

    this.service.getbranchlistmappingbyuseridandcompanyidforlogin(this.decode.unique_name, companyId.value, localStorage.getItem('token')).subscribe((res: any) => {
      let arr = []
      arr = res
      this.branchlist = arr.filter((e: any) => e.isactive == true)
      if (tokenAccessStr) {
        const tokenAccessObj = JSON.parse(tokenAccessStr);

        // Step 2: Modify the companyId
        tokenAccessObj.companyId = companyId.value; // Set this to the new companyId value
        if (res.length == 0) {
          tokenAccessObj.branchId = 0;
          this.branchid1.setValue(0);
        }
        else {
          tokenAccessObj.branchId = res[0].id;
          this.branchid1.setValue(this.branchlist[0].id)
        }

        this.service.setBranchId(Number(tokenAccessObj.branchId || 0));

        // Step 3: Save the updated object back to localStorage
        localStorage.setItem('tokenaccess', JSON.stringify(tokenAccessObj));
        sessionStorage.setItem('tokenaccess', JSON.stringify(tokenAccessObj));
        // 🔄 Refresh current route properly
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });



      }

      this.refreshMailAccess(companyId.value);

    })

  }

  branchchange(branchid: any) {
    const tokenAccessStr = localStorage.getItem('tokenaccess');
    if (tokenAccessStr) {
      const tokenAccessObj = JSON.parse(tokenAccessStr);

      // Step 2: Modify the companyId
      tokenAccessObj.branchId = branchid.value; // Set this to the new companyId value
      this.service.setBranchId(Number(branchid.value || 0));
      // Step 3: Save the updated object back to localStorage
      localStorage.setItem('tokenaccess', JSON.stringify(tokenAccessObj));
      sessionStorage.setItem('tokenaccess', JSON.stringify(tokenAccessObj));
      // 🔄 Refresh current route properly
      const currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }

  }

  financeyearchange(fyid: any) {
    const tokenAccessStr = localStorage.getItem('tokenaccess');
    if (tokenAccessStr) {
      const tokenAccessObj = JSON.parse(tokenAccessStr);

      // Step 2: Modify the companyId
      tokenAccessObj.financeId = fyid.value; // Set this to the new companyId value
      // Step 3: Save the updated object back to localStorage
      localStorage.setItem('tokenaccess', JSON.stringify(tokenAccessObj));
      sessionStorage.setItem('tokenaccess', JSON.stringify(tokenAccessObj));
      let currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
  }

  openmail() {
    if (!this.mailEnabled) {
      this.openMailUnavailableDialog(
        'Mail Module Unavailable',
        'Mail services are not enabled for your current company. Please contact Admin or HR for access.'
      );
      return;
    }

    this.mailService.loadAccounts(this.userid).subscribe({
      next: (accounts) => {
        if (!accounts?.length) {
          this.openMailUnavailableDialog(
            'Mail Account Not Configured',
            'No mail ID is configured for your account. Please contact Admin or HR for assistance.'
          );
          return;
        }

        const dialogconfig = new MatDialogConfig();
        dialogconfig.autoFocus = true;
        dialogconfig.disableClose = false;
        dialogconfig.maxHeight = '100vh';
        dialogconfig.maxWidth = '100vw';
        dialogconfig.height = "100%";
        dialogconfig.width = "100%";
        dialogconfig.panelClass = 'custom-dialog-container';
        dialogconfig.hasBackdrop = true;
        dialogconfig.data = { departmentid: this.userid };
        this.dialog.open(MailComponent, dialogconfig);
      },
      error: () => {
        this.openMailUnavailableDialog(
          'Mail Access Unavailable',
          'We could not verify your mail account right now. Please try again or contact Admin / HR.'
        );
      }
    });
  }

  private refreshMailAccess(companyId?: number) {
    this.mailService.loadAccess(companyId || this.tk.companyId).subscribe({
      next: (access) => {
        this.mailEnabled = !!access?.is_mail_enabled;
        if (this.mailEnabled) {
          this.mailService.startBackgroundMailSync(companyId || this.tk.companyId);
        } else {
          this.mailService.stopBackgroundMailSync();
        }
      },
      error: () => {
        this.mailEnabled = false;
        this.mailService.stopBackgroundMailSync();
      }
    });
  }

  private openMailUnavailableDialog(title: string, message: string) {
    this.dialog.open(MailAccountMissingDialogComponent, {
      autoFocus: false,
      width: '560px',
      maxWidth: 'calc(100vw - 24px)',
      panelClass: 'mail-account-missing-dialog-panel',
      data: { title, message }
    });
  }

  private syncToolbarHeight() {
    const height = this.hostElement.nativeElement.offsetHeight || 60;
    document.documentElement.style.setProperty('--app-toolbar-height', `${height}px`);
  }
}
